/* Response Time CSS */

import palette from '../../../../../theme/index';

export default theme => ({
    label: {
            color: "orange !important"
    },
    sizeDivider:{
        height:"3px"
    },
    autocomplete:{
        width:"90%",
        paddingLeft:"12px"
    },
    back:{
        backgroundColor:"rgb(27,27,27)"
    },
    textField:{
        transform: "translate(0px, -7px) scale(1)",
        fontSize: "13px"
    },
    contentCircular:{
        textAlign:"center", 
        //backgroundColor:"black"
    },
    incidentContent:{
        textAlign:"left",
        "& .MuiTypography-body1": {
            fontSize:"0.75rem"
        },
    },
    circular:{
        //color:"white"
    },
    textDate:{
        "& .MuiTypography-h5": {
          fontWeight: "bold",
          fontSize:"1.0rem"
        },
      },

})